import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import { getCopyPreviousPeriodDetails } from "../EventShiftsView/eventsWorkspaceCopy.utils";
import styles from "./PublishSchedulerEventsConfirmationModal.module.scss";

/**
 * Confirmation modal for Copy Previous Day / Week / Month in Event Workspace.
 * Visual design matches {@link PublishSchedulerEventsConfirmationModal}.
 */
function CopySchedulerPeriodConfirmationModal({
  t,
  isOpen,
  isLoading,
  calendarViewId,
  shiftCount = 0,
  eventCount = 0,
  onConfirm,
  onClose,
}) {
  const periodDetails = useMemo(
    () => getCopyPreviousPeriodDetails(calendarViewId),
    [calendarViewId],
  );

  const detailRows = [
    {
      label: t("scheduler.copyPreviousShiftsToCopy"),
      value: shiftCount,
    },
    {
      label: t("scheduler.copyPreviousEventsToCopy"),
      value: eventCount,
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={onClose}>
        <img src={crossIcon} alt="" />
      </span>
      <ModalBody className={styles["publish-modal-body"]}>
        <Text
          size="25px"
          marginBottom="16px"
          weight="500"
          align="left"
          color="#111b45"
        >
          {t(periodDetails.titleKey)}
        </Text>
        <p className={styles["publish-modal-message"]}>
          {t(periodDetails.introKey)}
        </p>
        <dl className={styles["publish-modal-details"]}>
          {detailRows.map(({ label, value }) => (
            <div key={label} className={styles["publish-modal-detail-row"]}>
              <dt>{label}:</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
        <p className={styles["publish-modal-message"]}>
          {t(periodDetails.descriptionKey)}
        </p>
        <p className={styles["publish-modal-question"]}>
          {t(periodDetails.confirmQuestionKey)}
        </p>
        <div className={styles["publish-modal-actions"]}>
          <button
            type="button"
            className="button button-round button-shadow"
            disabled={isLoading}
            onClick={onConfirm}
          >
            {t(periodDetails.confirmLabelKey)}
          </button>
          <button
            type="button"
            className="button button-round button-border button-dark"
            disabled={isLoading}
            onClick={onClose}
          >
            {t("cancel")}
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(CopySchedulerPeriodConfirmationModal);
